/**
 * Composable to access Google Tag Manager dataLayer
 *
 * GTM is initialized globally via the gtm.client.ts plugin.
 * This composable provides methods to push events to the dataLayer.
 */
export function useGtm() {
	return {
		push: (data: Record<string, unknown>) => {
			if (import.meta.client) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push(data);
			}
		},
		trackEvent: (event: Record<string, unknown>) => {
			if (import.meta.client) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push(event);
			}
		}
	};
}

// Type augmentation for window.dataLayer
declare global {
	interface Window {
		dataLayer: Record<string, unknown>[];
	}
}
